import { render, staticRenderFns } from "./CustomerInfoDialog.vue?vue&type=template&id=bed3974c&scoped=true"
import script from "./CustomerInfoDialog.vue?vue&type=script&lang=js"
export * from "./CustomerInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed3974c",
  null
  
)

export default component.exports